// extracted by mini-css-extract-plugin
export var closeButton = "_fw-2";
export var closeButtonIcon = "_fw-3";
export var lightboxContent = "_fw-1";
export var lightboxOverlay = "_fw-0";